import { createSelector, FavoriteEntity } from '../../shared';
import type { AppState } from '..';

export const getFavorites = createSelector<AppState, FavoriteEntity[], string[], FavoriteEntity[]>(
    'getFavorites',
    [
        (appState: AppState) => appState.data.hubState.favoritePersonsState.favoritePersons,
        (appState: AppState) => appState.data.hubState.favoritePersonsState.favoriteIdsBeingRemoved,
    ],
    (favorites, beingRemoved) =>
        favorites.filter(favorite => !beingRemoved.includes(favorite.favoriteId))
);
